import React, { useState } from 'react';

export function getHostname(url) {
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
}

// Google's generic "no favicon" globe is a 16px image even when 64px is requested.
const GENERIC_PLACEHOLDER_MAX_WIDTH = 16;

function AppIcon({ app }) {
  const [failed, setFailed] = useState(false);
  const hostname = getHostname(app.url);

  if (hostname && !failed) {
    return (
      <img
        className="app-favicon"
        src={`https://www.google.com/s2/favicons?domain=${hostname}&sz=64`}
        alt=""
        width="24"
        height="24"
        loading="lazy"
        onError={() => setFailed(true)}
        onLoad={(event) => {
          if (event.currentTarget.naturalWidth <= GENERIC_PLACEHOLDER_MAX_WIDTH) {
            setFailed(true);
          }
        }}
      />
    );
  }
  return (
    <span className="app-icon" aria-hidden="true">
      {(app.name || '?').trim().charAt(0).toUpperCase()}
    </span>
  );
}

export default AppIcon;